var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"card-category",class:_vm.colored && _vm.categorySlug},[_vm._v("\n  "+_vm._s(_vm.category)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }